import axios from 'axios';

class PremiumAccessService {
  constructor() {
    this.cache = null;
    this.cacheAt = 0;
    this.ttlMs = 15000;
  }

  async getSubscriptionStatus(force = false) {
    const now = Date.now();
    if (!force && this.cache && (now - this.cacheAt) < this.ttlMs) {
      return this.cache;
    }
    const response = await axios.get('/subscription/status');
    this.cache = response.data;
    this.cacheAt = now;
    return response.data;
  }

  async isPremium(force = false) {
    const status = await this.getSubscriptionStatus(force);
    return status?.status === 'ACTIVE';
  }

  clearCache() {
    this.cache = null;
    this.cacheAt = 0;
  }
}

export const premiumAccessService = new PremiumAccessService();
